import { Box, styled } from "@mui/joy";

export const FormRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  width: "100%",
  columnGap: 22,
}));
